import { render, staticRenderFns } from "./HomepageLayout.vue?vue&type=template&id=09cbf86d&lang=pug&"
import script from "./HomepageLayout.vue?vue&type=script&lang=js&"
export * from "./HomepageLayout.vue?vue&type=script&lang=js&"
import style0 from "./HomepageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
